import { useMemo } from 'react'

import { InvoiceLineColumn, InvoiceLineColumnValues } from '@features/invoices/types/invoiceLineColumn'

import { invoiceEditorElementRestrictionsByVariant } from '../constants/variants/invoiceEditorElementRestrictionsByVariant'
import { InvoiceEditorConfigurableElement } from '../types/invoiceEditorConfigurableElement'
import { InvoiceEditorElementRestriction } from '../types/invoiceEditorElementRestriction'
import { useInvoiceEditorVariant } from './useInvoiceEditorVariant'

export const useIsInvoiceEditorElementRestricted = (
  element: InvoiceEditorConfigurableElement,
  restriction: InvoiceEditorElementRestriction,
) => {
  const { invoiceEditorVariant } = useInvoiceEditorVariant()

  return useMemo(() => {
    const variantConfig = invoiceEditorElementRestrictionsByVariant[invoiceEditorVariant]
    const elementRestriction = variantConfig?.[element]

    if (elementRestriction !== undefined) {
      return elementRestriction === restriction
    }

    if ((InvoiceLineColumnValues as readonly string[]).includes(element)) {
      const { restriction: lineRestriction, except } = variantConfig?.invoiceLineColumns ?? {}
      if (except?.includes(element as InvoiceLineColumn)) {
        return false
      }

      return lineRestriction === restriction
    }

    return false
  }, [element, invoiceEditorVariant, restriction])
}
